if (!customElements.get('announcement-bar')) {
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('.announcement__slider');
        this.localization = this.querySelector('.announcement__localization');
        this.links = this.querySelectorAll('.js-announcement-link');
        this.menu = document.querySelector('.main-menu__content');
        this.isPaused = false;
  
        this.bindEvents();
        this.init();
      }
  
      disconnectedCallback() {
        if (this.moveLinksHandler) {
          window.removeEventListener('on:breakpoint-change', this.moveLinksHandler);
        }
  
        if (this.moveLocalizationHandler) {
          window.removeEventListener('on:breakpoint-change', this.moveLocalizationHandler);
        }
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
        }
      }
  
      bindEvents() {
        if (this.links) {
          this.moveLinksHandler = this.moveLinksHandler || this.moveLinks.bind(this);
          window.addEventListener('on:breakpoint-change', this.moveLinksHandler);
        }
  
        if (this.localization) {
          this.moveLocalizationHandler = this.moveLocalizationHandler
            || this.moveLocalization.bind(this);
          window.addEventListener('on:breakpoint-change', this.moveLocalizationHandler);
        }
  
        if (this.slider) {
          this.slider.addEventListener('mouseenter', this.pauseSlider.bind(this));
          this.slider.addEventListener('mouseleave', this.resumeSlider.bind(this));
        }
      }
  
      /**
       * Start sliders a slidin'
       */
      init() {
        if (this.slider) {
          const slides = this.slider.querySelectorAll('.announcement__text');
          slides[0].classList.add('is-visible');
          const isVertical = (this.dataset.scrollAxis === 'vertical');
          if (isVertical) {
            this.slider.classList.add('is-vertical');
            const setSliderHeight = () => {
              const arr = Array.from(slides || []);
              const maxH = arr.length ? Math.max.apply(null, arr.map(s => s.clientHeight || 0)) : 0;
              if (maxH > 0) {
                this.slider.style.height = maxH + 'px';
                this.slider.style.minHeight = maxH + 'px';
              }
            };
            setSliderHeight();
            this.resizeHandler = setSliderHeight;
            window.addEventListener('resize', this.resizeHandler);
          }
  
          const nextSlide = () => {
            if (!this.isPaused && theme.elementUtil.isInViewport(this)) {
              const currSlide = this.slider.querySelector('.announcement__text.is-visible');
              const currSlideIndex = Array.from(currSlide.parentNode.children)
                .indexOf(currSlide);
              const nextSlideIndex = currSlideIndex + 1 < slides.length ? currSlideIndex + 1 : 0;
  
              if (isVertical) {
                this.slider.scrollTo(0, slides[nextSlideIndex].offsetTop);
              } else {
                if (document.dir === 'rtl') {
                  this.slider.scrollTo(
                    -Math.abs(nextSlideIndex * slides[nextSlideIndex].clientWidth),
                    0
                  );
                } else {
                  this.slider.scrollTo(slides[nextSlideIndex].offsetLeft - 32, 0);
                }
              }
  
              slides[nextSlideIndex].classList.add('is-visible');
              slides[currSlideIndex].classList.remove('is-visible');
            }
  
            setTimeout(nextSlide, this.dataset.slideDelay);
          };
          setTimeout(nextSlide, this.dataset.slideDelay);
        }
  
        if (this.links) {
          this.moveLinks();
        }
  
        if (this.localization) {
          this.moveLocalization();
        }
      }
  
      /**
       * Move the help links selectors to the mobile nav/back to the announcement bar if necessary
       */
      moveLinks() {
        const menuAnnouncementLinks = document.querySelector('.mob__announcement-links');
        if (!theme.mediaMatches.md && !menuAnnouncementLinks) {
          // Move localization to mobile
          const mobNav = document.createElement('nav');
          mobNav.classList.add('mob__announcement-links');
  
          const mobNavUl = document.createElement('ul');
          mobNav.classList.add('secondary-nav');
  
          this.links.forEach((link) => {
            mobNav.innerHTML += `<li><a class="secondary-nav__item" href="${link.href}">${link.innerText}</a>`;
          });
  
          mobNav.appendChild(mobNavUl);
          this.menu.appendChild(mobNav);
        } else if (theme.mediaMatches.md && menuAnnouncementLinks) {
          menuAnnouncementLinks.remove();
        }
      }
  
      /**
       * Move the localization selectors to the mobile nav/back to the announcement bar if necessary
       */
      moveLocalization() {
        const menuLocalization = document.querySelector('.mob__localization');
        if (!theme.mediaMatches.md && !menuLocalization) {
          // Move localization to mobile
          const mobLocalizationElem = document.createElement('div');
          mobLocalizationElem.classList.add('mob__localization');
          mobLocalizationElem.appendChild(this.localization.firstElementChild);
          this.menu.appendChild(mobLocalizationElem);
        } else if (theme.mediaMatches.md && menuLocalization) {
          // Move localization back to announcement bar
          this.localization.appendChild(menuLocalization.firstElementChild);
          menuLocalization.remove();
        }
      }
  
      /**
       * Pauses the auto-rotating slider
       */
      pauseSlider() {
        this.isPaused = true;
      }
  
      /**
       * Resumes the auto-rotating slider
       */
      resumeSlider() {
        this.isPaused = false;
      }
    }
  
    customElements.define('announcement-bar', AnnouncementBar);
  }
  
  
  
  (async function () {
    const languages = {
      EN: 'en',
      DE: 'de',
      FR: 'fr',
      ES: 'es',
      IT: 'it',
      NL: 'nl'
    }
    const i18nLocale = {
      EN: 'en',
      EN_US: 'en-US',
      EN_CA: 'en-CA',
      EN_EU: 'en-EU',
      EN_GB: 'en-GB',
      EN_NO: 'en-NO',
      EN_CH: 'en-CH',
      EN_AU: 'en-AU',
      DE_DE: 'de-DE',
      FR_FR: 'fr-FR',
      ES_ES: 'es-ES',
      IT_IT: 'it-IT',
      NL_NL: 'nl-NL',
      ZH_CN: 'zh-CN'
    }
    const StoreDomain = {
      US: 'us.snapmaker.com',
      EU: 'eu.snapmaker.com',
      AU: 'au.snapmaker.com',
      GLOBAL: 'shop.snapmaker.com',
      CN: 'snapmaker.tmall.com'
    }
    const defaultRegions = [
      {
        name: `North America`,
        locations: [
          {
            country: `United States`,
            lang: `English`,
            i18nLocale: i18nLocale.EN_US,
            currency: `$ USD`
          },
          {
            country: `Canada`,
            lang: `English`,
            i18nLocale: i18nLocale.EN_CA,
            currency: `$ USD`
          },
        ],
      },
      {
        name: `Europe`,
        locations: [
          {
            country: `EU Countries`,
            lang: `English`,
            i18nLocale: i18nLocale.EN_EU,
            currency: `€ EUR`
          },
          {
            country: `Deutschland`,
            lang: `Deutsch`,
            i18nLocale: i18nLocale.DE_DE,
            currency: `€ EUR`
          },
          {
            country: `France`,
            lang: `Français`,
            i18nLocale: i18nLocale.FR_FR,
            currency: `€ EUR`
          },
          {
            country: `España`,
            lang: `Español`,
            i18nLocale: i18nLocale.ES_ES,
            currency: `€ EUR`
          },
          {
            country: `Italia`,
            lang: `Italiano`,
            i18nLocale: i18nLocale.IT_IT,
            currency: `€ EUR`
          },
          {
            country: `Nederland`,
            lang: `Nederlands`,
            i18nLocale: i18nLocale.NL_NL,
            currency: `€ EUR`
          },
          {
            country: `United Kingdom`,
            lang: `English`,
            i18nLocale: i18nLocale.EN_GB,
            currency: `$ USD`
          },
          {
            country: `Norway`,
            lang: `English`,
            i18nLocale: i18nLocale.EN_NO,
            currency: `$ USD`
          },
          {
            country: `Switzerland`,
            lang: `English`,
            i18nLocale: i18nLocale.EN_CH,
            currency: `$ USD`
          },
        ],
      },
      {
        name: `Asia Pacific & Global`,
        locations: [
          // {
          //   country: `中国大陆`,
          //   lang: `English`,
          //   // lang: `简体中文`,
          //   i18nLocale: i18nLocale.ZH_CN,
          //   currency: `$ USD`
          // },
          {
            country: `Australia`,
            lang: `English`,
            i18nLocale: i18nLocale.EN_AU,
            currency: `$ AUD`
          },
          {
            country: `Global`,
            lang: `English`,
            i18nLocale: i18nLocale.EN,
            currency: `$ USD`
          },
        ],
      },
    ]
    const countryToLangCode = (countryCode) => {
      switch (countryCode) {
        case 'AT':
        case 'BE':
        case 'BG':
        case 'HR':
        case 'CY':
        case 'CZ':
        case 'DK':
        case 'EE':
        case 'FI':
        case 'GR':
        case 'HU':
        case 'IE':
        case 'LV':
        case 'LT':
        case 'LU':
        case 'TM':
        case 'PL':
        case 'PT':
        case 'RO':
        case 'SK':
        case 'SI':
        case 'SE':
          return i18nLocale.EN_EU
        case 'FR': 
          return i18nLocale.FR_FR
        case 'ES':
          return i18nLocale.ES_ES
        case 'IT':
          return i18nLocale.IT_IT
        case 'NL':
          return i18nLocale.NL_NL
        case 'DE':
          return i18nLocale.DE_DE
        case 'US':
          return i18nLocale.EN_US
        case 'GB':
          return i18nLocale.EN_GB
        case 'NO':
          return i18nLocale.EN_NO
        case 'CH':
          return i18nLocale.EN_CH
        case 'AU':
          return i18nLocale.EN_AU
        case 'CN':
          return i18nLocale.ZH_CN
        default:
          return i18nLocale.EN
      }
    }
    const langCodeStoreDomain = (i18nLocaleCode) => {
      switch (i18nLocaleCode) {
        case i18nLocale.EN_EU:
        case i18nLocale.DE_DE:
        case i18nLocale.FR_FR:
        case i18nLocale.ES_ES:
        case i18nLocale.IT_IT:
        case i18nLocale.NL_NL:
          return StoreDomain.EU
        case i18nLocale.EN_US:
          return StoreDomain.US;
        case i18nLocale.EN_AU:
          return StoreDomain.AU;
        default:
          return StoreDomain.GLOBAL
      }
    }
    const langCodeTolange = (i18nLocaleCode) => {
      switch (i18nLocaleCode) {
        case i18nLocale.DE_DE:
          return languages.DE
        case i18nLocale.FR_FR:
          return languages.FR
        case i18nLocale.ES_ES:
          return languages.ES
        case i18nLocale.IT_IT:
          return languages.IT
        case i18nLocale.NL_NL:
          return languages.NL
        default:
          return languages.EN
      }
    }
    const localeRoutePrefix = (i18nLocaleCode) => {
      const langcode = langCodeTolange(i18nLocaleCode);
      const currentPathLanguage = Object.values(languages).find(language => window.location.pathname.startsWith(`/${language}`));
      const path = window.location.pathname.replace(`/${currentPathLanguage}`, '');
      if(i18nLocale.DE_DE === i18nLocaleCode
        || i18nLocale.FR_FR === i18nLocaleCode
        || i18nLocale.ES_ES === i18nLocaleCode
        || i18nLocale.IT_IT === i18nLocaleCode
        || i18nLocale.NL_NL === i18nLocaleCode) {
        return `/${langcode}${path}`
      }
      return `${path}`
    }
    
    
    const getLocation = async () => {
      let country_code, country_name
      try {
        // https://members.ip-api.com/#pricing
        // Rate limited 45 / min
        // const response = await fetch('http://ip-api.com/json');
        // apiserver proxy 
        const response = await fetch('https://api.snapmaker.com/v1/ip-geolocation');
        const geolocationData = await response.json();
        country_code = geolocationData.countryCode
        country_name = geolocationData.country
        if (response.status >= 400) {
          // https://ipinfo.io/developers/data-types#geolocation-data
          // Rate limited: 50,000 / mo
          // 7026c595e76acb
          const response = await fetch('https://ipinfo.io/json?token=860ed8b1d6f7cc')
          const geolocationData = await response.json();
          country_code = geolocationData.country  
          country_name = geolocationData.country // region
        }
      } catch (error) {
        console.error("geolocation error:", error)
        // https://ipinfo.io/developers/data-types#geolocation-data
        // Rate limited: 50,000 / mo
        const response = await fetch('https://ipinfo.io/json?token=860ed8b1d6f7cc')
        const geolocationData = await response.json();
        country_code = geolocationData.country
        country_name = geolocationData.country // region
      }
      return { country_code, country_name }
    }
  
    function generateRegionHTML(regions) {
      return regions.map(region => {
        const locationsHTML = region.locations.map(location => {
          return `
                  <a href="https://${langCodeStoreDomain(location.i18nLocale)}${localeRoutePrefix(location.i18nLocale)}" class="location-container" data-ly-locked>
                      <div class="location-country font-bw-2">
                          ${location.country}
                      </div>
                      <div class="location-lang font-bw-3"> <span class="location-language">${location.lang}</span> / <span class="location-momenty">${location.currency}</span> </div>
                  </a>
              `;
        }).join('');
  
        return `
              <div class="region-container">
                  <div class="region-name">${region.name}</div>
                  <div class="region-locations">
                      ${locationsHTML}
                  </div>
              </div>
          `;
      }).join('');
    }
  
    // 弹窗选择记录
    const POPUP_KEY = 'popup_choice';
    const IS_INSIST = 'is_insist'
    const EXPIRATION_TIME = 30 * 60 * 1000; // 30 minutes in milliseconds
  
    function saveToLocalStorage(key, options) {
      const item = {
        ...options,
        timestamp: Date.now()
      };
      localStorage.setItem(key, JSON.stringify(item));
    }
    function isExpired (key) {
      const item = JSON.parse(localStorage.getItem(key));
      if (!item) return true;
      return Date.now() - item.timestamp > EXPIRATION_TIME;
    }
    function saveChoice(selectedClose) { saveToLocalStorage(POPUP_KEY, {selectedClose}) }
    function isChoiceExpired() { return isExpired(POPUP_KEY) }
    function saveInsist(isInsist) { saveToLocalStorage(IS_INSIST, {isInsist}) }
    function isInsistExpired() { return isExpired(IS_INSIST) }
  
  
    const locale = document.querySelector('#snmk-locale')
    const localeModal = document.querySelector('.snmk-locale-modal')
    // Move modal to body to avoid stacking context / containing block issues
    // from parent elements with transform, filter, or z-index
    if (localeModal) {
      document.body.appendChild(localeModal)
    }
    const localeModalMask = document.querySelector('.snmk-locale-modal .snmk-mask')
    const localeModalPCClose = document.querySelector('.modalbody-title svg')
    const localeIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 0.0703125C9.26793 0.0703125 11.9297 2.72791 11.9297 6C11.9297 9.27212 9.27212 11.9297 6 11.9297C2.72791 11.9297 0.0703125 9.26793 0.0703125 6C0.0703128 2.72791 2.73207 0.0703125 6 0.0703125ZM4.48145 8.36035C4.64952 9.18159 4.89367 9.83764 5.15918 10.29C5.29186 10.5161 5.43134 10.6944 5.57129 10.8164C5.71048 10.9377 5.85625 11.0088 6 11.0088C6.14378 11.0088 6.28956 10.9376 6.42871 10.8164C6.56858 10.6945 6.70841 10.5168 6.84082 10.291C7.10578 9.83918 7.34868 9.18425 7.51465 8.36523L7.53125 8.28125H7.44629L4.5498 8.27637H4.46387L4.48145 8.36035ZM1.5918 8.37598C2.1535 9.41353 3.0713 10.2329 4.17773 10.666L4.35547 10.7354L4.26465 10.5674C4.17703 10.4047 4.0935 10.2296 4.01855 10.0381V10.0371L3.87598 9.64746C3.74101 9.24454 3.63004 8.8037 3.54492 8.33398L3.53418 8.27734L3.47559 8.27637L1.65332 8.27246H1.53516L1.5918 8.37598ZM8.45508 8.34277C8.3416 8.96474 8.18227 9.53921 7.98145 10.0371C7.9014 10.2267 7.82235 10.4058 7.73535 10.5674L7.64453 10.7354L7.82227 10.666C8.92857 10.2329 9.84254 9.42175 10.4043 8.39258L10.46 8.29004L10.3428 8.28906L8.52441 8.28516H8.46582L8.45508 8.34277ZM1.17969 4.62402C1.05552 5.06091 0.986985 5.51968 0.991211 6C0.991211 6.48855 1.06028 6.96466 1.19336 7.41113L1.33008 7.3916V7.35938L3.33203 7.36426H3.4082L3.40137 7.28711C3.36351 6.86637 3.34277 6.43732 3.34277 6C3.34277 5.54124 3.36419 5.09074 3.40625 4.65332L3.41309 4.57715H3.33594L1.24707 4.57227H1.19434L1.17969 4.62402ZM8.59375 4.6582C8.63583 5.09171 8.66113 5.54174 8.66113 6C8.66113 6.43752 8.64042 6.87111 8.60254 7.29199L8.5957 7.36816H8.67188L10.7695 7.37207H10.8232L10.8369 7.32129C10.9528 6.90073 11.0127 6.45858 11.0127 6C11.0127 5.52853 10.9487 5.06925 10.8242 4.63574L10.8096 4.58594L10.7568 4.58496L8.66406 4.58105H8.58691L8.59375 4.6582ZM4.33203 4.63477C4.28523 5.06023 4.25977 5.51583 4.25977 5.99609C4.25978 6.45476 4.28069 6.88839 4.32324 7.29688L4.33008 7.35938H4.39355L7.61133 7.36426H7.67383L7.68066 7.30078C7.72319 6.89237 7.74413 6.45886 7.74414 5.99609C7.74414 5.51649 7.72358 5.06122 7.67676 4.63965L7.66895 4.57715H7.60645L4.40137 4.57227H4.33887L4.33203 4.63477ZM7.73535 1.42871C7.82296 1.59142 7.90651 1.7665 7.98145 1.95801V1.95898C8.17802 2.4442 8.33378 3.00216 8.44727 3.60742L8.45801 3.66406H8.51562L10.3174 3.66797L10.4365 3.66895L10.3779 3.56445C9.81617 2.55247 8.91158 1.75466 7.82227 1.33008L7.64551 1.26074L7.73535 1.42871ZM6 0.987305C5.85844 0.987305 5.71481 1.05706 5.57715 1.17578C5.43888 1.29507 5.30053 1.4686 5.16895 1.68945C4.90552 2.13173 4.66226 2.77306 4.49414 3.5752L4.47656 3.66016H4.5625L7.4375 3.66406H7.52344L7.50586 3.58008C7.33779 2.77801 7.09586 2.13576 6.83301 1.69238C6.70165 1.47085 6.56336 1.29655 6.4248 1.17676C6.28684 1.0575 6.14263 0.987305 6 0.987305ZM4.17773 1.33008C3.0928 1.75462 2.19191 2.54768 1.62598 3.55078L1.56738 3.65527H1.68652L3.48438 3.66016H3.54199L3.55273 3.60254C3.66622 2.99735 3.82095 2.44331 4.01758 1.95801C4.09758 1.76857 4.17771 1.59019 4.26465 1.42871L4.35449 1.26074L4.17773 1.33008Z" fill="#6F6F6F" stroke="white" stroke-width="0.14"/>
      </svg>`
  
  
    const openModal = () => localeModal.style.display = 'block'
    const closeModal = () => {
      saveChoice(true)
      localeModal.style.display = 'none'
    }
  
    locale.addEventListener('click', openModal)
    localeModalMask.addEventListener('click', closeModal)
    localeModalPCClose.addEventListener('click', closeModal)
  
    const currentOrign = location.host;

    const currentLanguage = location.pathname.split('/').find(v => Object.values(languages).includes(v)) || 'en'
  
    const { country_code, country_name } = await getLocation();
    const recommendLocale = countryToLangCode(country_code);
    const recommendLanguage = langCodeTolange(recommendLocale);
  
    const regionContainerEL = document.querySelector('.snmk-locale-modal .region-list')
    const locations = defaultRegions.reduce((pre, curr) => {
      return pre.concat(curr.locations)
    }, [])
    const recommendRegions = {
      name: `Recommended visit`,
      locations: [locations.find(location => location.i18nLocale === recommendLocale)]
    }
  
    const regions = [recommendRegions, ...defaultRegions]
    const regionsHTML = generateRegionHTML(regions)

    // data-wg-notranslate stops Weglot from rewriting locale links
    regionContainerEL.setAttribute('data-wg-notranslate', '');

    regionContainerEL.innerHTML = regionsHTML
    
    const getCurrentLocation = () => {
      let currI18nLocale = ''
      if(currentLanguage === languages.EN && currentOrign === StoreDomain.US) {
        currI18nLocale = i18nLocale.EN_US
      } else if(currentLanguage === languages.EN && currentOrign === StoreDomain.AU) {
        currI18nLocale = i18nLocale.EN_AU
      } else if(currentLanguage === languages.EN && currentOrign === StoreDomain.GLOBAL) {
        currI18nLocale = i18nLocale.EN
      } else if(currentOrign === StoreDomain.EU) {
        if (currentLanguage === languages.DE) {
          currI18nLocale = i18nLocale.DE_DE
        } else if (currentLanguage === languages.FR) {
          currI18nLocale = i18nLocale.FR_FR
        } else if (currentLanguage === languages.ES) {
          currI18nLocale = i18nLocale.ES_ES
        } else if (currentLanguage === languages.IT) {
          currI18nLocale = i18nLocale.IT_IT
        } else if (currentLanguage === languages.NL) {
          currI18nLocale = i18nLocale.NL_NL
        } else {
          currI18nLocale = i18nLocale.EN_EU
        }
      } else {
        currI18nLocale = i18nLocale.EN
      }
      return locations.find(location => location.i18nLocale === currI18nLocale)
    }
    const currentLocation = getCurrentLocation()
    const i18nlocation = localeIcon + `${currentLocation.country} (${currentLocation.lang} / ${currentLocation.currency})`
    locale.innerHTML = i18nlocation

    // Official website link — points to snapmaker.com based on store + language
    const officialLink = document.querySelector('.announcement-official-website a');
    if (officialLink) {
      let officialUrl = 'https://www.snapmaker.com/en';
      if (currentOrign === StoreDomain.EU) {
        officialUrl = currentLanguage === languages.DE
          ? 'https://www.snapmaker.com/de-DE'
          : 'https://www.snapmaker.com/en-EU';
      } else if (currentOrign === StoreDomain.US) {
        officialUrl = 'https://www.snapmaker.com/en-US';
      }
      officialLink.href = officialUrl;
    }
  
    // footer
    const footerLocale = document.querySelector('#snmk-footer-locale')
    footerLocale.innerHTML = i18nlocation
    footerLocale.addEventListener('click', openModal)
  
  
    // mob
    const mobLocale = document.querySelector('#mob-snmk-locale')
    const modalClose = document.querySelector('.i18n-close-icon')
    mobLocale.addEventListener('click', openModal)
    modalClose.addEventListener('click', closeModal)
    mobLocale.innerHTML = i18nlocation
    window.addEventListener('on:header-toggle', (event) => {
      if(event.detail && !event.detail.isOpen) {
        closeModal()
      }
    });
  
    function goToCountry () {
        const newDomain = langCodeStoreDomain(recommendLocale);
        const localePrefix = localeRoutePrefix(recommendRegions.locations[0].i18nLocale);
        const newUrl = `https://${newDomain}${localePrefix}`;
        location.href = newUrl;
    }
  
    if (isInsistExpired() && langCodeStoreDomain(recommendLocale) !== currentOrign || recommendLanguage !== currentLanguage) {
      const i18nTip = document.querySelector('.i18n-tip')
      const localeTip = document.querySelector('#locale-tip')
      const currentIpLocationEL = document.querySelector('#ip-location')
      const switchRecommendLocaleBtn = document.querySelector('#switch-recommend-locale-btn')
      const tipCloseEL = document.querySelector('#i18n-tip-close')
      if (!i18nTip) return
      currentIpLocationEL.innerHTML = 'Select'
      switchRecommendLocaleBtn.innerHTML = `Go ${recommendRegions.locations[0].country}`
      currentIpLocationEL.addEventListener('click', () => {
        openModal()
      })
      switchRecommendLocaleBtn.addEventListener('click', () => {
        goToCountry();
      })
      tipCloseEL.addEventListener('click', () => {
        localeTip.style.display = 'none';
        const insistComfirmTip = document.querySelector('#insist-confirm-tip')
        const comfirmBtn = document.querySelector('#insist-confirm-btn')
        const goRecommendBtn = document.querySelector('#to-recommend-locale-btn')
        if(!insistComfirmTip || !comfirmBtn || !goRecommendBtn) return
        insistComfirmTip.style.display = 'flex'
        comfirmBtn.addEventListener('click', () => {
          saveInsist(true)
          i18nTip.style.display = 'none'
        })
        goRecommendBtn.addEventListener('click', () => {
          goToCountry();
        })
      })
      i18nTip.style.display = 'block'
    }
  })()
